module.exports = __webpack_public_path__ + "img/register.fc730547.jpg";